import { Hero } from "@/.storyblok/types/319751/storyblok-components";
import { BASE_PATH, getClient, version } from "./storyblok-client";
import { getStory } from "./storyblok-api";
import { fetchLayoutBlocks } from "./storyblok-layout";
import { logger } from '@/lib/logger';

async function fetchBlogPostPreviews() {
  try {
    const storyblokApi = getClient();
    const perPage = 20;
    let page = 1;
    let hasMoreStories = true;
    let allStories: any[] = [];
    const timestamp = Date.now();

    while (hasMoreStories) {
      const response = await storyblokApi.get(
        "cdn/stories",
        {
          starts_with: `${BASE_PATH}/articles`,
          is_startpage: false,
          resolve_relations: ["blog_page_target_defense.blog_author"],
          sort_by: "content.blog_details.date:desc",
          version,
          per_page: perPage,
          page: page,
          cv: timestamp,
        },
        {
          next: { revalidate: 3600 }
        }
      );

      const stories = response?.data?.stories || [];

      if (stories.length > 0) {
        allStories = [...allStories, ...stories];

        if (stories.length < perPage) {
          hasMoreStories = false;
        } else {
          page++;
        }
      } else {
        hasMoreStories = false;
      }
    }

    return (
      allStories.map((story: any) => ({
        slug: story.slug,
        name: story.name,
        content: story.content,
      })) || []
    );
  } catch (error) {
    logger.error("Error fetching blog post previews:", error);
    return [];
  }
}

export async function getBlogHomeContent() {
  try {
    const blogHomeStory = await getStory(
      `${BASE_PATH}/articles`,
      [
        "blog_homepage_target_defense.featured_top",
        "blog_homepage_target_defense.accreditations_big",
        "blog_selector.select_story",
        "blog_page_target_defense.blog_author",
      ],
      null
    );

    // logger.log(`blogHomeStory: ` + JSON.stringify(blogHomeStory, null, 2));

    const layoutBlocks = await fetchLayoutBlocks();

    const content = blogHomeStory?.content;
    const heroBlock =
      content?.hero?.find(
        (block: Hero) => block.component === "hero"
      ) || null;

    const allBlogPosts = await fetchBlogPostPreviews();
    logger.log(`allBlogPosts: ` + allBlogPosts.length);
    // logger.log(`allBlogPosts: ` + JSON.stringify(allBlogPosts, null, 2));

    return {
      blogHomeStory,
      headerBlock: layoutBlocks.headerBlock,
      footerBlock: layoutBlocks.footerBlock,
      trustSmallBlock: layoutBlocks.trustSmallBlock,
      customScriptBlock: layoutBlocks.customScriptBlock,
      stickyNavBlock: layoutBlocks.stickyNavBlock,
      heroBlock,
      allBlogPosts,
    };
  } catch (error) {
    logger.error("Error fetching blog home content:", error);
    return {
      blogHomeStory: null,
      headerBlock: null,
      footerBlock: null,
      trustSmallBlock: null,
      customScriptBlock: null,
      stickyNavBlock: null,
      heroBlock: null,
      allBlogPosts: [],
    };
  }
}

export async function getBlogPostContent(slug: string) {
  try {
    const blogPostStory = await getStory(
      `${BASE_PATH}/articles/${slug}`,
      [
        "blog_page_target_defense.accreditations_big",
        "blog_page_target_defense.blog_author",
      ],
      null
    );

    // logger.log(`blogPostStory: ` + JSON.stringify(blogPostStory, null, 2));

    const { headerBlock, footerBlock, trustSmallBlock, stickyNavBlock, customScriptBlock } =
      await fetchLayoutBlocks();

    const content = blogPostStory?.content;
    const heroBlock = content?.hero_blog_post?.[0] || null;

    return {
      blogPostStory: blogPostStory,
      headerBlock,
      footerBlock,
      trustSmallBlock,
      customScriptBlock,
      stickyNavBlock,
      heroBlock,
    };
  } catch (error) {
    logger.error(`Error fetching blog post content (${slug}):`, error);
    return {
      blogPostStory: null,
      headerBlock: null,
      footerBlock: null,
      trustSmallBlock: null,
      customScriptBlock: null,
      stickyNavBlock: null,
      heroBlock: null,
    };
  }
}
